import React from "react";
import NavigationComponent from "../components/NavigationComponent";
import moment from "moment";
import RangeContainerComponent from "./RangeContainerComponent";
import TableDailyStatsComponent from "./TableDailyStatsComponent";
import GraphComponent from "./GraphComponent";
import { AthleteLinks } from "../../../../parts/athlete-links";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import { ReportsBackHandler } from "../components/ReportsBackHandler";
import BackButton from "../../../../parts/BackButton";

const dateFormat = {
  normal: "YYYY-MM-DD",
  calendar: "MMM D, YYYY",
  utc: "YYYYMMDD",
};

class ReadinessRate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentAthlete: null,
      dateFrom: null,
      dateTo: null,
      quickDisabled: false,
      rangeSelector: {
        type: "months",
        value: 6,
      }, // in Weeks format
      filters: {
        sore: true,
        stress: true,
        energy: true,
        mood: true,
        sleep: true,
      },
      tooltip: {
        show: false,
        y: 0,
        x: 0,
        content: "",
      },
      sortedUpward: false,
      stats: [],
    };
    this.getArrayFormatted = this.getArrayFormatted.bind(this);
    this.getArrayFiltered = this.getArrayFiltered.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleToggleCheck = this.handleToggleCheck.bind(this);
    this.getDateFirstEntry = this.getDateFirstEntry.bind(this);
  }

  handleToggleCheck(name) {
    if (name === "date") {
      if (this.state.sortedUpward) {
        const sortedStats = this.state.stats.sort(
          (a, b) => a.utcDate - b.utcDate
        );
        this.setState({ stats: sortedStats, sortedUpward: false });
      } else {
        const sortedStats = this.state.stats.sort(
          (a, b) => b.utcDate - a.utcDate
        );
        this.setState({ stats: sortedStats, sortedUpward: true });
      }
      return;
    }

    const filters = Object.assign({}, this.state.filters, {
      [name]: !this.state.filters[name],
    });
    this.setState({ filters });
  }

  getArrayFiltered(arr) {
    const { dateFrom, dateTo, rangeSelector } = this.state;
    const { value, type } = rangeSelector;

    if (dateFrom && dateTo) {
      const formatedFrom = parseInt(
        moment(dateFrom, dateFormat.calendar).format(dateFormat.utc)
      );
      const formatedTo = parseInt(
        moment(dateTo, dateFormat.calendar).format(dateFormat.utc)
      );

      const filtered = arr.filter(({ utcDate }) => {
        const statDate = parseInt(utcDate);
        if (statDate === formatedFrom && statDate === formatedTo) return true;
        return !Boolean(statDate < formatedFrom || statDate > formatedTo);
      });
      return filtered;
    }

    if (type === "lifetime") return arr;
    const result = arr.filter(
      ({ date }) =>
        !Boolean(moment(new Date()).subtract(value, type).isAfter(date))
    );
    return result;
  }

  getArrayFormatted(arr = []) {
    const result = this.getArrayFiltered(
      arr.sort((a, b) => new Date(a.date) - new Date(b.date))
    )
      .filter((stats) => stats.readiness)
      .map((stats) => {
        const { sleep, mood, energy, stress, sore } = stats.readiness;

        return Object.assign({}, stats, {
          date: moment(stats.date, "YYYY-MM-DD").format(dateFormat.calendar),
          readiness: [sore, stress, energy, mood, sleep],
        });
      });

    return result;
  }

  componentDidMount() {
    const { value, type } = this.state.rangeSelector;
    const { athlete, activeUser, dailyStats } = this.context.locals;
    const athleteId = athlete ? athlete._id : activeUser._id;
    this.setState({
      currentAthlete: athleteId,
      dateFrom: moment(new Date(), dateFormat.normal)
        .subtract(value, type)
        .format(dateFormat.calendar),
      stats: this.getArrayFormatted(dailyStats),
    });
  }

  updateState(state) {
    this.setState(state);
  }

  getDateFirstEntry() {
    return this.context.locals.dailyStats
      .sort((a, b) => new Date(a.date) - new Date(b.date))
      .find((stats) => stats.readiness).date;
  }

  sortRecent(a, b) {
    return b.utcDate - a.utcDate;
  }
  sortOldest(a, b) {
    return a.utcDate - b.utcDate;
  }

  sortStatsByDate(stats = [], type = "recent") {
    if (type === "recent") return stats.sort(this.sortRecent);
    return stats.sort(this.sortOldest);
  }

  componentDidUpdate(prevProps, prevState) {
    const { locals } = this.context;
    const { dailyStats } = locals;
    const athleteId = locals.athlete
      ? locals.athlete._id
      : locals.activeUser._id;

    //if the athlete is changed
    if (athleteId !== this.state.currentAthlete) {
      //if the range date is not lifetime, we only update the athlete
      if (this.state.rangeSelector.type !== "lifetime") {
        this.setState({
          currentAthlete: athleteId,
        });
        //if range date is lifetime we set a default range
      } else {
        this.setState({
          currentAthlete: athleteId,
          dateFrom: moment("2015-12-31T07:57:45.121Z").format(
            dateFormat.calendar
          ),
        });
      }
    }

    if (
      prevState.dateFrom !== this.state.dateFrom ||
      prevState.dateTo !== this.state.dateTo
    ) {
      this.setState({
        stats: this.sortStatsByDate(
          this.getArrayFormatted(dailyStats),
          this.state.sortedUpward ? "recent" : "oldest"
        ),
      });
    }

    //change the stats state to update the render
    if (
      prevState.currentAthlete !== null &&
      this.state.currentAthlete !== athleteId
    ) {
      this.setState({ stats: this.getArrayFormatted(dailyStats) });
    }
  }

  render() {
    const { locals } = this.context;
    const { dateTo, dateFrom, filters, stats } = this.state;
    const { query, pathname, athlete } = locals;

    return (
      <>
        <div className="athlete-section-header only-show-mobile">
          <AthleteLinks
            athlete={athlete}
            pathName={pathname}
            classNames={"only-show-mobile"}
            query={query}
          />
          <div className="athlete-select dropdown-athlete">
            <div
              className="avatar"
              style={{
                backgroundImage: `url(${getAvatarUrl(locals.athlete)})`,
              }}
            />
            <AthleteSelect locals={locals} />
          </div>
        </div>
        <main role="reports-wrapper">
          <NavigationComponent
            query={query}
            text="Calendar Day View"
            pathName={pathname}
            classNames="mobile-hidden"
          />
          <article role="report-content">
            <hgroup className="flex gap-2 items-center mb-8 !justify-start">
              {query.showBack && <BackButton />}
              <h2 className="mobile-hidden">Readiness Rate</h2>
            </hgroup>
            <ReportsBackHandler title={"Readiness Rate"} locals={locals} />

            <RangeContainerComponent
              {...this.state}
              updateState={this.updateState}
              getDateFirstEntry={this.getDateFirstEntry}
              locals={locals}
            />
            <GraphComponent
              dateTo={dateTo}
              dateFrom={dateFrom}
              filters={filters}
              stats={stats}
              sectionClassNames={"mobile-hidden"}
              graphHeight={270}
              graphId={"readiness-rate-graph-desktop"}
            />
            <GraphComponent
              dateTo={dateTo}
              dateFrom={dateFrom}
              filters={filters}
              stats={stats}
              sectionClassNames={"only-show-mobile"}
              graphHeight={170}
              graphId={"readiness-rate-graph-mobile"}
            />
            <TableDailyStatsComponent
              {...this.state}
              handleToggleCheck={this.handleToggleCheck}
            />
          </article>
        </main>
      </>
    );
  }
}

export default ReadinessRate;
